import { render, staticRenderFns } from "./_universeid.vue?vue&type=template&id=bf68bae6&"
import script from "./_universeid.vue?vue&type=script&lang=ts&"
export * from "./_universeid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports